import * as Yup from 'yup';

const IFormCommisionSchema = Yup.object().shape({
  type: Yup.string()
    .when('V', {
      is: 'value',
      then: Yup.number().positive().required().min(1, 'Minímo R$ 1,00'),
    })
    .when('P', {
      is: 'value',
      then: Yup.number().integer().positive().required().min(1, 'Minímo 1%').max(100, 'Máximo 100%'),
    }),
});

export default IFormCommisionSchema;
